export const TRUST_LINE_INFINITE_VALUE = '922337203685.4775807'; // https://stellar-sdk.readthedocs.io/en/stable/_modules/stellar_sdk/operation/change_trust.html
